import React from 'react'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'

import Layout from '../components/en/common/Layout'
import { MetaData } from '../components/common/meta'
import SectionHeader from '../components/common/section-header'
import PortfolioMasonry from '../components/sections/portfolio-masonry'
import HeroTitle from '../components/sections/hero-title'
import Pagination from '../components/common/Pagination'

import '../styles/pages/page-ourwork.scss'

const pageOurWorkEn = ({ data, location, pageContext }) => {
	const posts = data.portfolioPosts.edges

	return (
		<>
			<MetaData
				data={data}
				location={location}
				type="website"
				linkAlternate={false}
			/>
			<Helmet>
				<link rel="alternate" href="https://think-plus.gr/our-work/" hreflang="el-gr" />
				<link rel="alternate" href="https://think-plus.gr/en/our-work/" hreflang="en" />
			</Helmet>
			<Layout>
				<article className="page-our-work">
					<div className="dec-section--line-vertical bottom">
						<HeroTitle>
							<SectionHeader title="PORTFOLIO" h1={true} text="Everything is designed.<br>Few things are designed well." />
						</HeroTitle>
					</div>
					<section className="posts-masonry">
						<div className="container">
							<div className="row">
                <div className="col">
									<PortfolioMasonry postList={posts} />
                  <Pagination pageContext={pageContext} />
                </div>
              </div>
						</div>
					</section>
					<div className="container our-work__footer">
						<div className="dec-section--line-vertical">
							<p className="h5 text-align-center">When you believe a thing, believe it all the way, <br />implicitly and unquestionably</p>
						</div>
					</div>
				</article>
			</Layout>
		</>
	)
}

export const allPostsQueryPortfolio = graphql`
  query($skip: Int!, $limit: Int!) {
    portfolioPosts: allGhostPost(
      limit: $limit,
      skip: $skip,
      sort: {order: DESC, fields: published_at},
      filter: {tags: {elemMatch: {name: {eq: "#portfolio"}}}}) {
      edges {
        node {
          ...GhostPostFields
        }
      }
    }
  }
`
export default pageOurWorkEn
